module.exports = __webpack_public_path__ + "img/contact_employer_phone.790ed0cc.jpg";